import React, { useEffect, useState, useRef } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography'
import Checkbox from "@material-ui/core/Checkbox";
import SideStyle from '../style/sideStyle';
import Param from '../store/param';
import Control from '../store/control';
import { toast } from 'react-toastify';

import { onSaveLocal } from '../fileIO/filesave';

import { useControls, folder, button, buttonGroup } from 'leva'
import { Button, FormControl, Input, InputLabel, Modal, Select, TextField, Paper } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { achilliServer } from '../../network';
import * as THREE from 'three';
import FeedbackTime from '../../components/Feedback';

const initialForm = {
  office: '',
  fileName: '',
  patiendId: '',
  socketType: '',
  ano: '',
  dno: ''
}

const QAForm = ({ show, setter }) => {

  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([]);

  const handleSubmit = async () => {
    if (input.trim() === '') return;

    setMessages([...messages, { text: input, sender: 'user' }]);
    setInput('');

    // Calling the OpenAI API (as an example, we call it directly from the front end, but in practice it should be done via the back end)
    // const response = await axios.post('https://api.openai.com/v1/engines/davinci/completions', {
    //   prompt: input,
    //   max_tokens: 150
    // }, {
    //   headers: {
    //     'Authorization': 'Bearer YOUR_OPENAI_API_KEY'
    //   }
    // });

    // const reply = response.data.choices[0].text.trim();
    const reply = ''
    setMessages([...messages, { text: reply, sender: 'gpt' }]);
  };

  return (
    <Modal
      open={show}
      onClose={() => setter(false)}
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      aria-labelledby="achilli-form"
      aria-describedby="achilli-data-builder"
    >
      <Grid container spacing={2} style={{ width: '50%', background: 'rgb(89 86 86 / 77%)', padding: 10, borderRadius: 8 }}>
        <Grid item xs={12}>
          <Typography variant="h4" align="center" style={{color: 'white'}}>AI Chatbot, Coming Soon...</Typography>
        </Grid>
        {/* Question */}
        <Grid item xs={12}>
          <TextField 
            value={input} 
            onChange={e => setInput(e.target.value)}
            fullWidth 
            placeholder="Type your message..."
            variant="outlined"
            inputProps={{
              style: {
                color: "white",
              }
            }}
          />
        </Grid>
        {/* send botton */}
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', gap: 5 }}>
          <Button onClick={handleSubmit} variant="outlined" color='primary'>Send</Button>
        </Grid>
        {/* Answer */}
        <Grid item xs={12}>
          <Paper style={{ height: '400px', overflow: 'auto', padding: '20px', marginBottom: '20px' }}>
          {messages.map((message, index) => (
            <div key={index} style={{ textAlign: message.sender === 'gpt' ? 'left' : 'right' }}>
              <Typography variant="body1">{message.text}</Typography>
            </div>
          ))}
          </Paper>
        </Grid>
        {/* cancel botton */}
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', gap: 5 }}>
          <Button onClick={() => setter(false)} variant="outlined" color='secondary'>Cancel</Button>
        </Grid>
      </Grid>
    </Modal>
  )
}

const AchilliForm = ({ show, setter, blob }) => {

  const selectedSocket = Control.Get('type');

  const [formDetails, setFormDetails] = useState(initialForm)

  const [uploading, setUploading] = useState(false)
  const [openPatientDD, setOpenDD] = useState(false)
  const [loading, setLoading] = useState(false)
  const [options, setOptions] = useState([])
  const [patientName, setPatientName] = useState('')
  const [amputations, setAmputations] = useState([])
  const [lastDNO, setLastDNO] = useState()
  const [dnos, setDnos] = useState([])

  const uploadFileToAchilli = async () => {
    if (!selectedSocket) return toast.error('Socket not selected')
    setUploading(true)
    const { patiendId: pid, ano, dno } = formDetails
    const kind = selectedSocket === 'TestSocket' ? 3 : 4
    const path = selectedSocket === 'TestSocket' ? `patientdata/${pid}/${dno}/testsocket/cad/` : `patientdata/${pid}/${dno}/final/cad/`
    const name = formDetails.fileName || new Date().getTime()
    const form = new FormData()
    const file = new File([blob], `${name}.json`, { type: 'application/json' });

    form.append('file', file)
    form.append('stump_flag', false)
    form.append('path', path)
    form.append('kind', kind)
    form.append('subno', 1)
    form.append('pid', pid)
    form.append('ano', ano)
    form.append('dno', dno)

    toast.info('Sending to achilli')

    try {
      const req = await achilliServer.post('/editor/upload/files/', form)
      if (req.status === 200) {
        toast.success('Uploaded to achilli')
      }
    } catch (error) {
      toast.error(error.message)
    } finally {
      setUploading(false)
      setter(false)
      setFormDetails(initialForm)
    }
  }

  const formUpdater = (name, ev) => {
    const { target } = ev
    setFormDetails((prevState) => ({
      ...prevState,
      [name]: target.value
    }))
  }

  const getPatients = async (e) => {
    setPatientName(e.target.value)
    setLoading(true)
    const res = await achilliServer.post('/editor/list/patient/?page=1&limit=40', { patient_name: e.target.value })
    setOptions(res?.data?.patients)
    setLoading(false)
  }

  const setPatientAndGetAno = async (e, value) => {
    setFormDetails(prev => ({ ...prev, patiendId: value.pk }))
    const res = await achilliServer.get(`/editor/${value.pk}/amp/0/info/`)
    setAmputations(res?.data?.all_amputations)
    setLastDNO(res?.data?.last_dno)
  }

  const setAnoAndGetDno = async (e) => {
    formUpdater('ano', e)
    const getDnos = await achilliServer.get(`/editor/dgns/stump/${formDetails?.patiendId}/${e?.target?.value}/${lastDNO}/`)
    setDnos(getDnos?.data?.all_diagnosis)
  }

  const isDisabled = () => {
    if (uploading || !formDetails?.patiendId || !formDetails?.ano || !formDetails?.dno || !formDetails?.fileName) return true
    else return false
  }

  return (
    <Modal
      open={show}
      onClose={() => setter(false)}
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      aria-labelledby="achilli-form"
      aria-describedby="achilli-data-builder"
    ><Grid container spacing={2} style={{ width: '50%', background: 'rgb(89 86 86 / 77%)', padding: 10, borderRadius: 8 }}>
        <Grid item xs={6}>
          <Autocomplete
            id="patients"
            open={openPatientDD}
            onOpen={() => {
              setOpenDD(true);
            }}
            onClose={() => {
              setOpenDD(false);
            }}
            onChange={(e, value) => setPatientAndGetAno(e, value)}
            getOptionSelected={(option, value) => option.patient_name === value.patient_name}
            getOptionLabel={(option) => option.patient_name}
            options={options}
            loading={loading}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Patient Name"
                variant="outlined"
                value={patientName}
                onChange={e => getPatients(e)}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={6}><FormControl style={{ width: '100%' }} variant="outlined">
          <InputLabel htmlFor="filled-age-native-simple">Select Amputation</InputLabel>
          <Select
            native
            value={formDetails.ano || ''}
            onChange={(e) => setAnoAndGetDno(e)}
            inputProps={{
              name: 'ano',
              id: 'amp-selection',
            }}
            key={JSON.stringify(amputations)}
          >
            <option value=''>Select</option>
            {amputations?.map(amp => <option key={amp?.no} value={amp?.no}>{`${amp?.no} (${amp?.side_name} ${amp?.pro_type_name})`}</option>)}
          </Select>
        </FormControl></Grid>
        <Grid item xs={6}><TextField
          style={{ width: '100%' }}
          label="File Name"
          value={formDetails.fileName || ''}
          id="outlined-start-adornment"
          variant="outlined"
          onChange={e => formUpdater('fileName', e)}
        /></Grid>
        <Grid item xs={6}><FormControl style={{ width: '100%' }} variant="outlined">
          <InputLabel htmlFor="filled-age-native-simple">Select Diagnosis</InputLabel>
          <Select
            native
            value={formDetails.dno || ''}
            onChange={(e) => formUpdater('dno', e)}
            inputProps={{
              name: 'ano',
              id: 'amp-selection',
            }}
            key={JSON.stringify(dnos)}
          >
            <option value=''>Select</option>
            {dnos?.map(dno => <option key={dno?.dno} value={dno?.dno}>{`${dno?.dno} (${dno?.pro_type})`}</option>)}
          </Select>
        </FormControl></Grid>
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', gap: 5 }}>
          <Button onClick={() => setter(false)} variant="outlined" color='primary'>Cancel</Button>
          <Button disabled={isDisabled()} onClick={uploadFileToAchilli} variant="outlined" color='primary'>Upload</Button>
        </Grid>
      </Grid>
    </Modal >
  )
}

const ShowCheckbox = () => {
  const activeStep = Param.Get('activeStep');
  const setParam = Param.Get('setParam');
  const setup = Param.Get('setup');
  const readFromJsonAk = Param.Get('readFromJsonAk');
  const setControl = Control.Get('setControl');
  const meshLeg = Control.Get('meshLeg');
  const alignedMeshLeg = Control.Get('alignedMeshLeg');
  const prosthetics = Control.Get('prosthetics');

  const paramJson = Param.toBlob();
  const fileInputRef = useRef(null);

  const [save, setSave] = useState(false);
  const [jsonData, setJsonData] = useState(null);

  const [showAchilliForm, setShowAchilliForm] = useState(false);
  const [QA, setQA] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false); // Add state to manage FeedbackTime visibility

  const [datas, set] = useControls(() => ({
    ['Measure Distance']: button(() => {
      toast.info('Please click 2 points. Measure distance beween the two points');
      setControl(s => { s.measure = !s.measure });
    }),
    ['Show Leg']: true,
    ['Show Socket']: true,
    ['Show Trim Surface']: true,
    ['Leg Wireframe']: false,
    ['Leg Transparent']: false,
    ['Leg Traslation']: folder({
      x: 0,
      y: 0,
      z: 0,
    }),
    ['Save Parameter']: button(() => {
      console.log('saveParam');
      setSave(true);
      setShowFeedback(true); // Show FeedbackTime modal
    }),
    ['Load Parameter']: button(() => {
      console.log('loadParam');
      fileInputRef.current.click();
    }),
    ["Upload To DB"]: button(() => {
      setShowAchilliForm(true)
    }, { disabled: true }),
    ["AI based Q&A"]: button(() => {
      setQA(true)
    }, { disabled: true }),
  }))

  useEffect(() => {
    if (prosthetics == 'BK') {
      if (activeStep <= 2) { // SETUP, ALIGNMENT, MARKING
        // show only leg because there is no socket data by activeStep 2.
        set({ 'Show Leg': true })
        set({ 'Show Socket': false })
      } else if (activeStep == 3) { // MODIFYING
        // set showLeg as false to show socket only because mesh leg is copied to socket for modifying.
        set({ 'Show Leg': false })
        set({ 'Show Socket': true })
      } else if (activeStep == 4 || activeStep == 5) { // COMPRESS< TRIMMING
        set({ 'Show Leg': true })
        set({ 'Show Socket': true })
      }
    } else if (prosthetics == 'AK') {
    }
  }, [activeStep]);

  useEffect(() => {
    setControl(s => {
      s.showLeg = datas['Show Leg'],
      s.showSocket = datas['Show Socket'],
      s.showTrimSurface = datas['Show Trim Surface'],
      s.wireLeg = datas['Leg Wireframe'],
      s.transparentLeg = datas['Leg Transparent']
    })
    setParam(s => {
      s.setup.globalTranslationX = datas.x,
      s.setup.globalTranslationY = datas.z, // z is y due to axis is different
      s.setup.globalTranslationZ = datas.y
    })
  }, [datas]);

  // save modeling paraemters and aligned leg mesh data.
  useEffect(() => {
    if (save) {
      var leg = null;
      if (alignedMeshLeg) { // aligned mesh is saved after alignment step
        leg = alignedMeshLeg.clone() // use aligned mesh which is one before initial angle adjustment
        let geometry = leg.geometry.clone()
        if (setup.side == 1) {
          var mS = (new THREE.Matrix4()).identity();
          mS.elements[0] = -1;
          // apply matrix to leg geometry
          geometry = geometry.applyMatrix4(mS);
          leg.geometry = geometry;
        }
      } else {
        toast.error('Please finish alignment step. Only save modeling parameter now.');
      }

      onSaveLocal(paramJson, leg)
      setSave(false)
    }
  }, [save]);

  // load modeling parameters.
  useEffect(() => {
    if (jsonData) {
      readFromJsonAk(jsonData) // read from json
      setJsonData(null)
      setParam(s => {s.setup.loadParam = true})
      setParam(s => {s.align.step = 0}) // reset align step
      setParam(s => {s.trim.step = 0}) // reset trim step
      setParam(s => {s.setup.globalTranslationX = 0}) // reset global translation
      setParam(s => {s.setup.globalTranslationY = 0}) // reset global translation
      setParam(s => {s.setup.globalTranslationZ = 0}) // reset global translation
    }
  }, [jsonData]);


  /**
   * Read JSON file and set parameters
   * @param {*} e
   * @returns
   */
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // read file content
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const fileContent = event.target.result;
        const parsedJson = JSON.parse(fileContent);
        setJsonData(parsedJson);
        console.log('JSON data:', parsedJson);
        toast.info('Parameters loaded');
      } catch (error) {
        console.error('Error parsing JSON file:', error);
      }
    };
    reader.readAsText(file);
  };

  return (
    <div>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept='.json'
        hidden // hide input element
      />
      <AchilliForm blob={paramJson} show={showAchilliForm} setter={setShowAchilliForm} />
      <QAForm show={QA} setter={setQA} />
      <FeedbackTime show={showFeedback} setter={setShowFeedback} /> {/* Add FeedbackTime component */}
    </div>
  );
}
export default ShowCheckbox;

